import { URL_APL_REGISTRATION } from 'src/config/url'

export const redirectToPartnerRegistration = () => {
  window.open(URL_APL_REGISTRATION, '_blank')
}
